<div style="text-align: center;">
  <p-chart #chart type="bar" [data]="basicDataYears" [options]="horizontalOptionsYears" height="150px"></p-chart>
</div>
